import React, { useEffect } from "react";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/pro-light-svg-icons";
import { useTranslation } from "react-i18next";

const ProductAppPreview = ({
  img = null,
  dishCategory = null,
  isTodaySpecial = false,
  title = "Title",
  subtitle = "... km",
  price = null,
  number = 10,
}) => {
  const { t } = useTranslation();
  useEffect(() => {
    if (!dishCategory) return;
    try {
      if (!img) return;
      /*             
      import(`../../assets/img/dishCategories/${dishCategory?.label}.svg`)
        .then(image => setImgPath(image.default))
        .catch(error => {
          console.error("Failed to load image:", error);
          toast.error("Failed to load image");
        })
      */
    } catch (error) {
      console.error("Failed to load image:", error);
      toast.error("Failed to load image");
    }
  }, [img, dishCategory]);

  return (
    <div
      className={`${isTodaySpecial ? "todayspecial" : "product"}-preview-card`}
    >
      <div
        className={`${
          isTodaySpecial ? "todayspecial" : "product"
        }-preview-img bg-${!img ? "white" : "pastel-light"}`}
      >
        {img ? (
          <img
            className="custom-img"
            src={img}
            alt={dishCategory?.label || ""}
          />
        ) : (
          <span className="h1 text-light">{t(`utils.common.noImage`)}</span>
        )}
      </div>
      {isTodaySpecial ? (
        <div className="todayspecial-preview-text">
          <div className="todayspecial-text-section">
            <h4>{title}</h4>
            <div className="p4">{subtitle}</div>
            <div className="mt-auto">{`${price || "..."} CHF`}</div>
          </div>
        </div>
      ) : (
        <div className="product-preview-text">
          <div className="w-80">
            <h4>{title}</h4>
            <div className="p4">{subtitle}</div>
          </div>
          <div className="p3">
            <FontAwesomeIcon icon={faStar} className="mr-1" />
            <span>{number}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductAppPreview;
